"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const recharts_1 = require("recharts");
const format_1 = require("../../utils/format");
const material_1 = require("@mui/material");
const CustomChartToolTip_1 = __importDefault(require("./CustomChartToolTip"));
const themes_1 = require("@/theme/themes");
const CustomToolTip_1 = __importDefault(require("../interactions/CustomToolTip"));
const styledComponents_1 = require("../styledComponents");
const height = 350;
const CustomLineChart = ({ chartTitle, data, yAxisUnit, isPageLoading, stacked, yAxisdivider, tooltipPayload, tooltipTitle, }) => {
    const [width, setWidth] = (0, react_1.useState)(window.innerWidth);
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const handleResize = () => {
        setWidth(window.innerWidth);
    };
    if (!isPageLoading && data) {
        return (react_1.default.createElement(styledComponents_1.ChartContainer, null,
            react_1.default.createElement(styledComponents_1.CustomCardHeader, null,
                react_1.default.createElement(material_1.Box, { sx: { marginRight: '15px' } }, chartTitle),
                tooltipTitle && react_1.default.createElement(CustomToolTip_1.default, { description: tooltipTitle })),
            react_1.default.createElement(styledComponents_1.GridChartInner, null,
                react_1.default.createElement(recharts_1.ResponsiveContainer, { height: height + 10 },
                    react_1.default.createElement(recharts_1.AreaChart, { data: data },
                        react_1.default.createElement(recharts_1.Legend, { iconSize: 18, layout: width > 960 ? 'vertical' : 'horizontal', align: "left", verticalAlign: width > 960 ? 'top' : 'bottom', height: 50, formatter: (n) => (react_1.default.createElement(styledComponents_1.CustomLegend, { style: {
                                    textTransform: 'capitalize',
                                    fontSize: '.9em',
                                } }, n.replace('origyn', 'ORIGYN'))), style: { textTransform: 'capitalize' } }),
                        react_1.default.createElement(recharts_1.CartesianGrid, { vertical: false, stroke: '#363636' }),
                        react_1.default.createElement(recharts_1.Tooltip, { position: width > 600 ? null : { x: 0, y: -140 }, wrapperStyle: { outline: 'none' }, content: react_1.default.createElement(CustomChartToolTip_1.default, { data: data, customPayload: tooltipPayload ? tooltipPayload : data }) }),
                        react_1.default.createElement(recharts_1.XAxis, { dataKey: 'date', tick: { fontSize: '0.7em' } }),
                        react_1.default.createElement(recharts_1.YAxis, { padding: { top: 10 }, height: 370, axisLine: false, tickLine: false, tickMargin: 20, unit: yAxisUnit, tick: {
                                fontSize: '0.7em',
                            }, tickFormatter: (value) => (Number(value.toFixed(0)) / (yAxisdivider ? yAxisdivider : 1)).toString() }),
                        Object.getOwnPropertyNames(data[0]).map((e, i) => {
                            if (e !== 'date') {
                                return (react_1.default.createElement(recharts_1.Area, { stackId: stacked && e !== 'totalSupply' ? '1' : '', key: i, name: (0, format_1.formatLabel)(e), fill: `url(#${e})`, dataKey: e, stroke: themes_1.darkTheme.colors.charts[i], strokeWidth: 2, activeDot: { r: 2 } }));
                            }
                        }),
                        react_1.default.createElement("defs", null, Object.getOwnPropertyNames(data[0]).map((e, i) => {
                            if (e !== 'date') {
                                return (react_1.default.createElement("linearGradient", { key: i, id: e, x1: "0", y1: "0", x2: "0", y2: "1" },
                                    react_1.default.createElement("stop", { offset: "10%", stopColor: themes_1.darkTheme.colors.charts[i], stopOpacity: 0.1 }),
                                    react_1.default.createElement("stop", { offset: "90%", stopColor: themes_1.darkTheme.colors.charts[i], stopOpacity: 0 })));
                            }
                        })))))));
    }
};
exports.default = CustomLineChart;
